import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard, RecipeCard, EmptyState } from "@/components/kit";
import { Users, CalendarDays } from "lucide-react";
import { toast } from "sonner";

const DISCUSSION = [
  { a: "Maya Torres", t: "Anyone tried the new small-batch release? Worth the hunt?" },
  { a: "Bill Carter", t: "Best budget bottle for a big-batch punch this weekend?" },
  { a: "Sarah Lin", t: "Sharing my beach setup — palomas were the MVP 🏖️" },
];

export default function GroupDetail() {
  const { id } = useParams();
  const [g, setG] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/groups/${id}`).then((r) => setG(r.data)); }, [id]);
  if (!g) return <div className="p-12 text-center text-muted-foreground">Loading group…</div>;

  return (
    <div>
      <div className="relative h-56 overflow-hidden lg:h-72">
        <img src={g.image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
        <div className="absolute bottom-0 mx-auto flex w-full max-w-5xl items-end justify-between px-6 pb-6">
          <div><h1 className="font-display text-4xl lg:text-5xl">{g.name}</h1><p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground"><Users size={14} /> {g.members.toLocaleString()} members</p></div>
          <button data-testid="group-join-btn" onClick={() => toast.success(`Joined ${g.name}`)} className="rounded-full bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground">Join</button>
        </div>
      </div>

      <div className="mx-auto grid max-w-5xl gap-8 px-6 py-8 lg:grid-cols-[1fr_300px]">
        <div className="space-y-8">
          <p className="text-muted-foreground">{g.about}</p>
          <section>
            <h2 className="mb-3 font-display text-2xl">Discussion</h2>
            <div className="space-y-3">
              {DISCUSSION.map((d, i) => <div key={i} className="rounded-xl border border-border bg-card p-4"><p className="text-sm font-semibold">{d.a}</p><p className="mt-1 text-sm text-muted-foreground">{d.t}</p></div>)}
            </div>
          </section>
          {g.recipes?.length > 0 && (
            <section><h2 className="mb-3 font-display text-2xl">Top recipes</h2><div className="grid grid-cols-2 gap-4 lg:grid-cols-3">{g.recipes.map((r) => <RecipeCard key={r.id} r={r} />)}</div></section>
          )}
        </div>
        <aside className="space-y-6">
          <div>
            <h3 className="mb-3 font-semibold">Trending bottles</h3>
            {g.products?.length ? <div className="space-y-4">{g.products.map((p) => <ProductCard key={p.id} p={p} />)}</div> : <EmptyState title="No bottles yet" />}
          </div>
          <div className="rounded-xl border border-border bg-card p-4">
            <h3 className="mb-2 flex items-center gap-2 font-semibold"><CalendarDays size={16} className="text-primary" /> Featured event</h3>
            <p className="text-sm">Monthly tasting night</p>
            <p className="text-xs text-muted-foreground">Sat · Hosted by the community</p>
          </div>
        </aside>
      </div>
    </div>
  );
}
